import React from 'react';
import MediumButton from './MediumButton';
import SmallButton from './SmallButton';
import colors from '../../utils/colors';

// Icons
const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99992 8.99358L4.5221 12.4714C4.39198 12.6015 4.22637 12.6666 4.02527 12.6666C3.82417 12.6666 3.65856 12.6015 3.52844 12.4714C3.39831 12.3413 3.33325 12.1757 3.33325 11.9746C3.33325 11.7735 3.39831 11.6079 3.52844 11.4777L7.00626 7.99992L3.52844 4.5221C3.39831 4.39198 3.33325 4.22637 3.33325 4.02527C3.33325 3.82417 3.39831 3.65856 3.52844 3.52844C3.65856 3.39831 3.82417 3.33325 4.02527 3.33325C4.22637 3.33325 4.39198 3.39831 4.5221 3.52844L7.99992 7.00626L11.4777 3.52844C11.6079 3.39831 11.7735 3.33325 11.9746 3.33325C12.1757 3.33325 12.3413 3.39831 12.4714 3.52844C12.6015 3.65856 12.6666 3.82417 12.6666 4.02527C12.6666 4.22637 12.6015 4.39198 12.4714 4.5221L8.99358 7.99992L12.4714 11.4777C12.6015 11.6079 12.6666 11.7735 12.6666 11.9746C12.6666 12.1757 12.6015 12.3413 12.4714 12.4714C12.3413 12.6015 12.1757 12.6666 11.9746 12.6666C11.7735 12.6666 11.6079 12.6015 11.4777 12.4714L7.99992 8.99358Z" fill="#FAF7F5"/>
  </svg>
);

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99996 10.3834C7.91107 10.3834 7.82774 10.3695 7.74996 10.3417C7.67218 10.314 7.59996 10.2667 7.53329 10.2001L5.13329 7.80008C4.99996 7.66675 4.93607 7.51119 4.94163 7.33341C4.94718 7.15564 5.01107 7.00008 5.13329 6.86675C5.26663 6.73341 5.42496 6.66397 5.60829 6.65841C5.79163 6.65286 5.94996 6.71675 6.08329 6.85008L7.33329 8.10008V3.33341C7.33329 3.14453 7.39718 2.98619 7.52496 2.85841C7.65274 2.73064 7.81107 2.66675 7.99996 2.66675C8.18885 2.66675 8.34718 2.73064 8.47496 2.85841C8.60274 2.98619 8.66663 3.14453 8.66663 3.33341V8.10008L9.91663 6.85008C10.05 6.71675 10.2083 6.65286 10.3916 6.65841C10.575 6.66397 10.7333 6.73341 10.8666 6.86675C10.9888 7.00008 11.0527 7.15564 11.0583 7.33341C11.0638 7.51119 11 7.66675 10.8666 7.80008L8.46663 10.2001C8.39996 10.2667 8.32774 10.314 8.24996 10.3417C8.17218 10.3695 8.08885 10.3834 7.99996 10.3834ZM3.99996 13.3334C3.63329 13.3334 3.3194 13.2029 3.05829 12.9417C2.79718 12.6806 2.66663 12.3667 2.66663 12.0001V10.6667C2.66663 10.4779 2.73051 10.3195 2.85829 10.1917C2.98607 10.064 3.1444 10.0001 3.33329 10.0001C3.52218 10.0001 3.68051 10.064 3.80829 10.1917C3.93607 10.3195 3.99996 10.4779 3.99996 10.6667V12.0001H12V10.6667C12 10.4779 12.0638 10.3195 12.1916 10.1917C12.3194 10.064 12.4777 10.0001 12.6666 10.0001C12.8555 10.0001 13.0138 10.064 13.1416 10.1917C13.2694 10.3195 13.3333 10.4779 13.3333 10.6667V12.0001C13.3333 12.3667 13.2027 12.6806 12.9416 12.9417C12.6805 13.2029 12.3666 13.3334 12 13.3334H3.99996Z" fill="#FAF7F5"/>
  </svg>
);

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.87183 13.6667C4.54039 13.6667 4.25667 13.5487 4.02067 13.3127C3.78467 13.0767 3.66667 12.793 3.66667 12.4616V4.00007H3.5C3.35833 4.00007 3.23961 3.95212 3.14383 3.85623C3.04794 3.76034 3 3.64157 3 3.4999C3 3.35812 3.04794 3.2394 3.14383 3.14373C3.23961 3.04796 3.35833 3.00007 3.5 3.00007H6C6 2.83684 6.0575 2.69773 6.1725 2.58273C6.28739 2.46785 6.42644 2.4104 6.58967 2.4104H9.41033C9.57356 2.4104 9.71261 2.46785 9.8275 2.58273C9.9425 2.69773 10 2.83684 10 3.00007H12.5C12.6417 3.00007 12.7604 3.04801 12.8562 3.1439C12.9521 3.23979 13 3.35857 13 3.50023C13 3.64201 12.9521 3.76073 12.8562 3.8564C12.7604 3.95218 12.6417 4.00007 12.5 4.00007H12.3333V12.4616C12.3333 12.793 12.2153 13.0767 11.9793 13.3127C11.7433 13.5487 11.4596 13.6667 11.1282 13.6667H4.87183ZM6.7695 11.3334C6.91117 11.3334 7.02989 11.2855 7.12567 11.1897C7.22133 11.0938 7.26917 10.9751 7.26917 10.8334V5.8334C7.26917 5.69173 7.22122 5.57296 7.12533 5.47707C7.02956 5.38129 6.91078 5.3334 6.769 5.3334C6.62733 5.3334 6.50861 5.38129 6.41283 5.47707C6.31717 5.57296 6.26933 5.69173 6.26933 5.8334V10.8334C6.26933 10.9751 6.31722 11.0938 6.413 11.1897C6.50889 11.2855 6.62772 11.3334 6.7695 11.3334ZM9.231 11.3334C9.37267 11.3334 9.49139 11.2855 9.58717 11.1897C9.68283 11.0938 9.73067 10.9751 9.73067 10.8334V5.8334C9.73067 5.69173 9.68278 5.57296 9.587 5.47707C9.49111 5.38129 9.37228 5.3334 9.2305 5.3334C9.08883 5.3334 8.97011 5.38129 8.87433 5.47707C8.77867 5.57296 8.73083 5.69173 8.73083 5.8334V10.8334C8.73083 10.9751 8.77878 11.0938 8.87467 11.1897C8.97044 11.2855 9.08922 11.3334 9.231 11.3334Z" fill="#FAF7F5"/>
  </svg>
);

const FolderIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.88894 12.2221C3.58339 12.2221 3.32181 12.1133 3.10422 11.8958C2.88663 11.6782 2.77783 11.4166 2.77783 11.111V4.44436C2.77783 4.13881 2.88663 3.87723 3.10422 3.65964C3.32181 3.44205 3.58339 3.33325 3.88894 3.33325H6.76394C6.91209 3.33325 7.0533 3.36103 7.18755 3.41659C7.32181 3.47214 7.43987 3.55084 7.54172 3.6527L8.33339 4.44436H12.7778C13.0834 4.44436 13.345 4.55316 13.5626 4.77075C13.7801 4.98834 13.8889 5.24992 13.8889 5.55547V11.111C13.8889 11.4166 13.7801 11.6782 13.5626 11.8958C13.345 12.1133 13.0834 12.2221 12.7778 12.2221H3.88894ZM3.88894 11.111H12.7778V5.55547H7.87505L6.76394 4.44436H3.88894V11.111ZM8.4445 8.88881L7.93061 9.4027C7.82876 9.50455 7.77783 9.63418 7.77783 9.79159C7.77783 9.94899 7.82876 10.0786 7.93061 10.1805C8.03246 10.2823 8.16209 10.3333 8.3195 10.3333C8.47691 10.3333 8.60654 10.2823 8.70839 10.1805L10.1667 8.72214C10.2778 8.61103 10.3334 8.4814 10.3334 8.33325C10.3334 8.1851 10.2778 8.05547 10.1667 7.94436L8.70839 6.48603C8.60654 6.38418 8.47691 6.33325 8.3195 6.33325C8.16209 6.33325 8.03246 6.38418 7.93061 6.48603C7.82876 6.58788 7.77783 6.71751 7.77783 6.87492C7.77783 7.03233 7.82876 7.16196 7.93061 7.26381L8.4445 7.7777H6.66672C6.50931 7.7777 6.37737 7.83094 6.27089 7.93742C6.16441 8.0439 6.11117 8.17584 6.11117 8.33325C6.11117 8.49066 6.16441 8.6226 6.27089 8.72909C6.37737 8.83557 6.50931 8.88881 6.66672 8.88881H8.4445Z" fill="#FAF7F5"/>
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 2C7.52661 2 7.14286 2.38376 7.14286 2.85714V7.14286L2.85714 7.14286C2.38376 7.14286 2 7.52661 2 8C2 8.47339 2.38376 8.85714 2.85714 8.85714H7.14286V13.1429C7.14286 13.6162 7.52661 14 8 14C8.47339 14 8.85714 13.6162 8.85714 13.1429V8.85714H13.1429C13.6162 8.85714 14 8.47339 14 8C14 7.52661 13.6162 7.14286 13.1429 7.14286L8.85714 7.14286V2.85714C8.85714 2.38376 8.47339 2 8 2Z" fill="#FAF7F5"/>
  </svg>
);


const MultiSelect = ({ 
  selectedCount = 0, 
  onClear, 
  onDownload, 
  onNewWorkspace, 
  onAddToPlaylist, 
  onDelete,
  className = "" 
}) => {
  if (selectedCount === 0) return null;

  return (
    <>
      {/* Add CSS animation styles */}
      <style>
        {`
          @keyframes slideUp {
            0% {
              opacity: 0;
              transform: translateY(100px);
            }
            50% {
              opacity: 0;
              transform: translateY(50px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      
      <div 
        className={`flex justify-start items-center gap-3 px-3 py-2.5 rounded-full backdrop-blur-[50px] bg-[#252020]/30 animate-slideUp ${className}`} 
        style={{ 
          border: '0.5px solid rgba(255, 255, 255, 0.1)', 
          boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.3)',
          animation: 'slideUp 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        }}
      >
      {/* Selection indicator */}
      <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 h-11 gap-2 p-3 rounded-xl">
        <SmallButton
          leftIcon={<CloseIcon />}
          onClick={onClear}
          variant="secondary"
        />
        <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-white">
          {selectedCount} Selected
        </p>
      </div>

      {/* Action buttons */}
      <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 gap-2">
        <MediumButton
          text="Workspace"
          leftIcon={<FolderIcon />}
          onClick={onNewWorkspace}
          variant="secondary"
        />
        
        <MediumButton
          text="Playlist"
          leftIcon={<PlusIcon />}
          onClick={onAddToPlaylist}
          variant="secondary"
        />
        
        <MediumButton
          leftIcon={<DownloadIcon />}
          onClick={onDownload}
          variant="secondary"
        />
        
        <MediumButton
          leftIcon={<TrashIcon />}
          onClick={onDelete}
          variant="secondary"
          style={{
            backgroundColor: colors.states.danger
          }}
        />
      </div>
      </div>
    </>
  );
};

export default MultiSelect;